import { Component, inject, OnInit } from "@angular/core";
import { GetReportController } from "@arch/presentation/controllers/get-report.controller";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-redirect",
    imports: [],
    templateUrl: "./redirect.component.html",
    styleUrl: "./redirect.component.scss"
})
export class RedirectComponent implements OnInit {
    private readonly getReportController = inject(GetReportController);
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);

    async ngOnInit(): Promise<void> {
        const { companyId, reportId, liveToken, contactId, userId } =
            this.route.snapshot.queryParams;
        const report = await this.getReportController.execute({
            reportId: reportId
        });
        const types: Record<string, string> = {
            dashboard: "/dashboard",
            dre: "/dre",
            dreComparation: "/dre",
            balance: "/balanco",
            balanceComparation: "/balanco",
            budget: "/orcamento"
        };
        this.router.navigate([types[report.type]], {
            queryParams: { companyId, reportId, liveToken, contactId, userId }
        });
    }
}
